<template>
  <div class="cost-estimation-grid my-6">
    <div class="d-flex flex-column monthly-cost">
      <span class="text-h4"
        >{{ hide ? "£----" : formatMoney({ amount: monthlyCost }) }}&nbsp;</span
      >
      <span>Monthly</span>
    </div>
    <div class="d-flex flex-column">
      <span class="text-h4"
        >{{ hide ? "£----" : formatMoney({ amount: annualCost }) }}&nbsp;</span
      >
      <span>Yearly</span>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IMeterpoint } from "@/models/meterpoint/meterpoint.types"
  import { MeterpointService } from "@/services/MeterpointService"
  import { formatMoney } from "@/helpers/moneyHelpers"
  import tariffHelper from "@/helpers/tariffHelper"
  import { useCurrentAccountStore } from "@/stores/currentAccount"

  export default defineComponent({
    props: {
      meterpoint: {
        type: Object as PropType<IMeterpoint>,
        required: true,
      },
      hide: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        MeterpointService,
        formatMoney,
      }
    },
    computed: {
      tariff() {
        return MeterpointService.getMeterpointTariffs(
          this.meterpoint.identifier,
          this.current.coreId.data,
        ).data.currentTariff
      },
      annualCost() {
        return this.tariff
          ? tariffHelper.annualCost(this.tariff, this.meterpoint.registers)
          : 0
      },
      monthlyCost() {
        return this.annualCost / 12
      },
    },
  })
</script>

<style>
  .cost-estimation-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
</style>
